module.exports = __webpack_public_path__ + "img/lava.66ef013c.png";